import { DeepPartial } from '@apollo/client/utilities'
import { AtsRequisitionApprovableMetadataFragment } from 'generated/resources/graphql'

export const getAtsRequisitionMetadata = (
  data: DeepPartial<AtsRequisitionApprovableMetadataFragment>
) => {
  return [data.jobPostingTitle, data.team?.name].filter(Boolean)
}
